module.exports = __webpack_public_path__ + "static/media/point_cover_default.d6c7f37d.png";